<history-item
  [historyItem]="historyItem"
  [actionText]="getActionText(historyItem)"
  [statusStyle]="getStatusStyle(historyItem.VerificationStatus)"
  [statusIcon]="getStatusIcon(historyItem.VerificationStatus)"
  (onMessagesClicked)="messageClicked($event)"></history-item>